import { registerPageSections } from "../../registry";
import { ContentfulPageProvider } from "../../context/ContentfulPageContext";
import { useExperiment } from "@iscr/xAppLib/Hooks/useExperiment";
import { WAIT_TIME_EXP } from "@iscr/views/pages/homepage/consts"

const LandingPage = ({ page, siteStatus, preload, isStatic = false, parsedFunctions = {}, isPreview = false }) => {
	if (!page) return preload ? <div dangerouslySetInnerHTML={{ __html: preload }} /> : null;
	
	return (
	<ContentfulPageProvider initialPreview={isPreview} pageData={page}>
		<LandingPageContent
			page={page}
			siteStatus={siteStatus}
			isStatic={isStatic}
			parsedFunctions={parsedFunctions}
		/>
	</ContentfulPageProvider>
	)
	
};

const LandingPageContent = ({page, siteStatus, isStatic, parsedFunctions}) => {
	const waitTimeExp = useExperiment(WAIT_TIME_EXP, { quiet: true });

	return (
			<main className="contentful-page bg-white overflow-hidden">
				{registerPageSections(page, siteStatus, isStatic, parsedFunctions, { waitTimeExp })}
			</main>
		);
}

export default LandingPage;
